<template>
  <div v-if="smsCampaign" class="space-y-8">
    <EditSmsCampaignForm :sms-campaign="smsCampaign" />
    <DeleteSmsCampaign v-if="canDelete" :sms-campaign="smsCampaign" />
  </div>
</template>

<script>
import EditSmsCampaignForm from './components/EditSmsCampaignForm.vue';
import DeleteSmsCampaign from './components/DeleteSmsCampaign.vue';

export default {
  components: {
    DeleteSmsCampaign,
    EditSmsCampaignForm,
  },
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canDelete() {
      return ['DRAFT', 'CANCELLED', 'FAILED', 'COMPLETED'].indexOf(this.smsCampaign.status) >= 0;
    },
  },
};
</script>
